import React from 'react';
import LoaderOverlay from './LoaderOverlay';

interface FullScreenLoaderOverlayProps {
  isOpen: boolean;
}

const FullScreenLoaderOverlay: React.FC<FullScreenLoaderOverlayProps> = ({
  isOpen,
}) => <LoaderOverlay isOpen={isOpen} isFullscreen={true} />;

export default FullScreenLoaderOverlay;
